import React from "react";

const Instructions = () => {
  return <div>This is instructions view</div>;
};

export default Instructions;
